import "./shortcutsMenu.scss";
import React, { useContext, useEffect, useState } from "react";

import LoginButton from "./buttons/LoginButton";
import AccountButton from "./buttons/AccountButton";
import SearchIcon from "./buttons/SearchIcon";
import { LoginDrawer } from "@sbi-international/boutik.gatsby.plugin.account";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { MagentoCustomerContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/magentoCustomerContext";
import { ICustomerInfo, useCustomerInfo } from "@sbi-international/boutik.gatsby.plugin.services";
import { useHasMounted } from "../../hooks/useHasMounted";
import SiteLocaleSelectionPopupMenu from "../siteLocale/SiteLocaleSelectionPopupMenu";
import { CartButton, CartContext } from "@sbi-international/boutik.gatsby.plugin.checkout";

type ShortcutsMenuProps = {
  searchOpen: boolean;
  setSearchOpen: (searchOpen: boolean) => void;
};

export default function ShortcutsMenu(props: ShortcutsMenuProps) {
  const { searchOpen, setSearchOpen } = props;

  const customerInfo = useCustomerInfo();
  const { isLoginDrawerOpen, setIsLoginDrawerOpen } = useContext(CartContext);

  const magentoCustomerContext = useContext(MagentoCustomerContext);

  const hasMounted = useHasMounted();
  const [isLoginDrawerOpenNormal, setIsLoginDrawerOpenNormal] = useState<boolean>(false);

  const { navigateTranslated } = usePageLocalization();

  if (!hasMounted) return null;

  const LoginOrLogoutButton = !magentoCustomerContext.isAuthenticated ? (
    <LoginButton />
  ) : (
    <AccountButton currentUser={customerInfo?.customerInfo as ICustomerInfo} />
  );

  const closeLoginDrawer = () => {
    setIsLoginDrawerOpen(false);
    setIsLoginDrawerOpenNormal(false);
  };

  return (
    <>
      <LoginDrawer
        isOpen={isLoginDrawerOpenNormal || isLoginDrawerOpen}
        onClose={() => closeLoginDrawer()}
        onCreateAccountClick={() => setTimeout(() => navigateTranslated("/register/"), 300)}
        onForgotPasswordClick={() => setTimeout(() => navigateTranslated("/forgot-password/"), 300)}
      />
      <ul className="nav shortcutsMenu">
        <li>
          <SearchIcon searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
        </li>
        <li className="languageSelector">
          <SiteLocaleSelectionPopupMenu />
        </li>
        <li
          className="account"
          onClick={() => !magentoCustomerContext.isAuthenticated && setIsLoginDrawerOpenNormal(true)}
        >
          {LoginOrLogoutButton}
        </li>
        <li>
          <CartButton />
        </li>
      </ul>
    </>
  );
}
